/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  StationPerformanceInitialProperties,
  StationPerformanceList,
} from '../../interface/station-performance.interface';
import stationManagement from '../../utils/api/station-management';

const initialState: StationPerformanceInitialProperties = {
  selectedChargingPoint: null,
  stationListLoading: false,
  stationPerformanceList: [],
};

// Async thunk
export const fetchChargingStationList = createAsyncThunk<StationPerformanceList[], void>(
  'station-management/fetchChargingStationList',
  async (_, { dispatch }) => {
    try {
      const response = await stationManagement.fetchChargingStationList({});
      return response.data;
    } catch (error: any) {
      dispatch({
        type: 'notification/setNotificationMessage',
        payload: {
          type: 'error',
          CONNREFUSED: error?.response?.data?.code || 200,
          message: error?.response?.data?.message || 'Something went wrong!',
          status: true,
        },
      });
      throw error;
    }
  },
);

export const stationPerformanceSlice = createSlice({
  name: 'station-performance',
  initialState,
  reducers: {
    /**
     * Function to update selectedChargingPoint
     * @param {any} state - The current state.
     * @param {any} action - The action object.
     */
    setSelectedStation: (state, action) => {
      state.selectedChargingPoint = action.payload;
    },
  },
  /**
   * Use the extra reducers function
   * @param {any} builder - The builder object.
   */
  extraReducers: (builder) => {
    // Extra reducer
    builder
      .addCase(fetchChargingStationList.pending, (state) => {
        state.stationListLoading = true;
      })
      .addCase(
        fetchChargingStationList.fulfilled,
        (state, action: PayloadAction<StationPerformanceList[]>) => {
          state.stationPerformanceList = action.payload;
          state.stationListLoading = false;
        },
      )
      .addCase(fetchChargingStationList.rejected, (state) => {
        state.stationListLoading = false;
      });
  },
});

export const { setSelectedStation } = stationPerformanceSlice.actions;
export default stationPerformanceSlice.reducer;
